export default "__VITE_ASSET__Ds5yg9B9__"